import React, { useState, useEffect } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

export const Wordmark = ({ size }) => (
  <span className="wordmark" style={size ? { fontSize: size } : undefined}>
    NINJ<span className="jx">A</span>THLETI<span className="jx">C</span>LUB
  </span>
);

const navItems = [
  { to: "/shop", label: "The Art" },
  { to: "/train", label: "Train" },
  { to: "/recover", label: "Recover" },
  { to: "/mindset", label: "Mindset" },
];

export default function Layout() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <>
      <nav className="nac">
        <div className="wrap navin">
          <Link to="/" className="brand" aria-label="Ninja Athletic Club home">
            <Wordmark size={17} />
          </Link>
          <div className="navlinks">
            {navItems.map((n) => (
              <NavLink key={n.to} to={n.to} className={({ isActive }) => (isActive ? "active" : "")}>
                {n.label}
              </NavLink>
            ))}
          </div>
          <Link className="navcta" to="/shop">
            Shop the Drop
          </Link>
          <button
            className="navburger"
            aria-label={open ? "Close menu" : "Open menu"}
            onClick={() => setOpen(!open)}
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
        {open && (
          <div className="mobilemenu">
            {navItems.map((n) => (
              <Link key={n.to} to={n.to}>
                {n.label}
              </Link>
            ))}
            <Link to="/shop">Shop the Drop</Link>
          </div>
        )}
      </nav>

      <main>
        <Outlet />
      </main>

      <footer className="nac">
        <div className="wrap">
          <div className="fgrid">
            <div className="fcol">
              <Link to="/" aria-label="Ninja Athletic Club home">
                <Wordmark size={15} />
              </Link>
              <p style={{ marginTop: 14 }}>
                Warrior mindset art and hybrid training culture. Born in Dallas. Forged daily.
              </p>
            </div>
            <div className="fcol">
              <h4>Club</h4>
              <ul>
                <li><Link to="/shop">The Art</Link></li>
                <li><Link to="/train">Train</Link></li>
                <li><Link to="/recover">Recover</Link></li>
                <li><Link to="/mindset">Mindset</Link></li>
              </ul>
            </div>
            <div className="fcol">
              <h4>Family</h4>
              <ul>
                <li><a href="https://ninjathlete.com" rel="noopener noreferrer" target="_blank">NinjAthlete</a></li>
                <li><a href="https://ninjarunclub.com" rel="noopener noreferrer" target="_blank">NinjaRunClub</a></li>
                <li><a href="https://www.instagram.com/ninjathleticlub/" rel="noopener noreferrer" target="_blank">Instagram</a></li>
              </ul>
            </div>
            <div className="fcol">
              <h4>Support</h4>
              <ul>
                <li><Link to="/shipping">Shipping</Link></li>
                <li><Link to="/returns">Returns</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>
          </div>
          <div className="legal">
            <span>© 2026 Ninja Athletic Club. All rights reserved.</span>
            <span>Discipline today. Freedom tomorrow.</span>
          </div>
        </div>
      </footer>
    </>
  );
}
